// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"MainContentMeuHotelCadastroCondicaoAcomodacao_sectionTitle__1Ii_r","placeholderShimmer":"MainContentMeuHotelCadastroCondicaoAcomodacao_placeholderShimmer__1ZO8Y"};